export * from './IFlag';